import React from "react";

// Anonymized silhouette avatar (DESIGN-INVENTORY §4): a gradient circle with a
// light-blue head + shoulders and a soft ring. Never carries a photo or initials —
// the whole point is that the player cannot be identified.
const AnonSilhouetteAvatar = ({ size = 52 }) => (
  <div
    className="rounded-full flex items-end justify-center overflow-hidden flex-shrink-0"
    style={{
      width: size,
      height: size,
      background: "linear-gradient(160deg, #33517A 0%, #1E3350 100%)",
      boxShadow: "0 0 0 3px #E7F0FE",
    }}
    aria-label="Anonymized profile"
  >
    <svg width={size} height={size} viewBox="0 0 52 52" aria-hidden="true">
      <circle cx="26" cy="20" r="9" fill="#B7CCE8" />
      <path d="M10 46c0-9.4 7.2-15 16-15s16 5.6 16 15z" fill="#B7CCE8" />
    </svg>
  </div>
);

export default AnonSilhouetteAvatar;
